import dayjs from 'dayjs';
import * as yup from 'yup';
import { FiscalYear } from '../../../../global/entities/BuyOrder';

export const fiscalYearValidationSchema = yup.object().shape({
  firstClosingDate: yup
    .string()
    .required('Du måste välja ett slutdatum för året'),
});

export const formatFirstClosingDate = (date?: string) => {
  if (!date) {
    return '';
  }

  return dayjs(date).format('YYYY-MM-DD');
};

export const fiscalYearOptions: (keyof typeof FiscalYearLabel)[] = [
  FiscalYear.JanuaryStart,
  FiscalYear.MayStart,
  FiscalYear.JulyStart,
  FiscalYear.SeptemberStart,
];

export const FiscalYearLabel = {
  [FiscalYear.JanuaryStart]: '1 januari - 31 december',
  [FiscalYear.MayStart]: '1 maj - 30 april',
  [FiscalYear.JulyStart]: '1 juli - 30 juni',
  [FiscalYear.SeptemberStart]: '1 september - 31 augusti',
};
